import { z } from 'zod';

export const ControlSchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    controlCode: z.string().optional(),
    domain: z.string().optional(),
    control: z.string().optional(),
    name: z.string().optional(), // Alias for control
    controlWeight: z.number().min(1).max(10).optional().default(5),
    status: z.string().optional().default('Active'),
    effectiveness: z.string().optional(),
    controlType: z.string().optional(),
    references: z.array(z.string()).optional().default([]),
    relatedObligations: z.array(z.string()).optional().default([]),
    categories: z.array(z.string()).optional().default([]),
    scope: z.string().optional(),
    description: z.string().optional(),
    implementationNotes: z.string().optional(),
    owner: z.string().optional(),
    lastReviewDate: z.string().optional(), // Expected YYYY-MM-DD
    nextReviewDate: z.string().optional(),
    tenantId: z.string().optional(),
    customFields: z.record(z.unknown()).optional(),
    createdAt: z.any().optional(),
    updatedAt: z.any().optional(),
});

export const CreateControlSchema = ControlSchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateControlSchema = ControlSchema.partial();
export const ControlFormSchema = ControlSchema;

/** PUT /control/scope-preference — deprecated (writes moved to admin catalogs) */
export const UpdateTenantControlScopePreferenceSchema = z.object({
    scope_standards: z.array(z.string().trim().min(1)).default([]),
    category_domains: z.array(z.string().trim().min(1)).default([]),
    catalog_seed_tags_filter: z.array(z.string().trim().min(1)).default([])
});

/** PUT /tenant-compliance/catalogs/:tag */
export const UpdateTenantComplianceCatalogSchema = z.object({
    active: z.boolean(),
    scope_standards: z.array(z.string().trim().min(1)).optional(),
    category_domains: z.array(z.string().trim().min(1)).optional(),
    /** Empty / omitted with no change semantics handled in controller; empty array = all controls */
    control_ids: z.array(z.string().trim().min(1)).optional(),
});
